import relatedStores from './relatedStores';

export default relatedStores;
